import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Container, Title, Image } from "@mantine/core";
import ReferralTable from "@/components/tables/ReferralTable";
import Navbar from "@/components/layout/Navbar";
import InlineBanner from "@/components/shared/InlineBanner";
import styles from "./home-page.module.scss";

function HomePage() {
  const location = useLocation();
  const [state, setState] = useState(location.state || {});

  return (
    <Navbar>
      <Container fluid>
        {state.success && (
          <>
            <InlineBanner
              type="success"
              message="Referral sent! You may now refer another patient."
              key="Successful referral"
              dismissable
              onDismiss={() => setState({})}
            />
            <br />
          </>
        )}
        <Title className={styles.heading}>{"Home"}</Title>
        <div className={styles.welcomeContent}>
          <div>
            <h1>{"Welcome to Claimable"}</h1>
            <h2>
              {
                "We’re thrilled you’re here to bring powerful, hassle-free appeals to your patients."
              }
            </h2>
            <div className={styles.welcomeContentSubBanner}>
              <h6>{"Start with a Free Month"}</h6>
              <p className={styles.freeMonthText}>
                {
                  "Try Claimable free for the first month, with unlimited appeals. No payment info needed—just results."
                }
              </p>
              <p>
                {"Need Help? "}
                <Link to="mailto:support@getclaimable.com">{"Let’s Talk"}</Link>
                {" or "}
                <Link
                  to="https://www.loom.com/share/fa96de12fd014828846d8dcfb8098634?sid=e9f32ec5-060e-40d0-b144-c98aaf382e8f"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {"Watch a Demo"}
                </Link>
              </p>
            </div>
          </div>
          <div className={styles.welcomeContentImageContainer}>
            <Image
              src="/images/product_illustrations/woman_with_laptop.svg"
              alt="doctor using laptop"
              className={styles.welcomeContentImage}
              h={210}
            />
          </div>
        </div>

        <ReferralTable />
      </Container>
    </Navbar>
  );
}

export default HomePage;
